export enum IndexStatus {
    Available = 'available',
    Processing = 'processing',
    Deleting = 'deleting',
    Stuck = 'stuck',
    Failed = 'failed',
}